import PropTypes from 'prop-types';

// Componente simplificado - La validación se hace en DocumentContext
const PublicDocumentRoute = ({ children }) => {
  // Solo renderiza los children, no necesita layout ni validación
  // La validación del documento se hace en DocumentContext
  return children;
};

PublicDocumentRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicDocumentRoute;